import type { MediaResponse, Question } from 'src/types/helios/Question';

/**
 * Converts the question's field-keyed `mediaResponses` shape into the
 * `Record<string, MediaResponse[]>` map that `replaceMediaIdsWithUrls`
 * accepts.
 *
 * Filters out non-array entries defensively — the API response can have
 * null/undefined slots for fields with no attached media, and passing
 * those through would break the downstream `.filter/.map` calls.
 *
 * Consumed by both the task question-info expander and the mobile
 * perform-audit page — hence shared/domain rather than a feature.
 */
export function getQuestionMediaMap(
  question: Question | undefined,
): Record<string, MediaResponse[]> {
  if (!question?.mediaResponses) return {};
  return Object.fromEntries(
    Object.entries(question.mediaResponses).filter(([, value]) => Array.isArray(value)),
  );
}
